import React, { Component } from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import enhance from './enhance';
import Home from '../home';
import Login from '../login';
import '../slide.css';

class App extends Component {
  render() {
    const { isLoggedIn } = this.props;
    return (
      <div className="app">
        <ReactCSSTransitionGroup
          transitionName="slide-right"
          transitionEnterTimeout={500}
          transitionLeaveTimeout={500}
        >
          {!this.props.isLoggedIn && <Login key="login" />}
        </ReactCSSTransitionGroup>
        <ReactCSSTransitionGroup
          transitionName="slide-left"
          transitionEnterTimeout={500}
          transitionLeaveTimeout={500}
        >
          {this.props.isLoggedIn && <Home key="home" />}
        </ReactCSSTransitionGroup>
      </div>
    );
  }
}

export default enhance(App);



// WEBPACK FOOTER //
// ./src/components/app/index.js